export const ISendTipUseCaseType = Symbol('ISendTipUseCase');
